import React, { Component } from 'react';
import { MDBDataTableV5 } from 'mdbreact';
import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap/dist/js/bootstrap.js';
import { dataVillager } from "../../assets/dataVillager";

const myData = dataVillager;

export default function DataTable_Villager() {
  const [datatable, setDatatable] = React.useState({
    columns: [
      {
        label: 'Name',
        field: 'name',
        width: 150,
        attributes: {
          'aria-controls': 'DataTable',
          'aria-label': 'Name',
          
        },
      },
      {
        label: 'Gender',
        field: 'gender',
        width: 270,
      },
      {
        label: 'Personality',
        field: 'personality',
        width: 200,
      },
      {
        label: 'Species',
        field: 'species',
        sort: 'asc',
        width: 100,
      },
      {
        label: 'Birthday',
        field: 'birthday',
        sort: 'asc',
        width: 150,
      },
      {
        label: 'Catchphrase',
        field: 'catchphrase',
        sort: 'asc',
        width: 100,
      },
      {
        label: 'Hobby',
        field: 'hobby',
        sort: 'asc',
        width: 100,
      },
    ],
    rows: myData,
  });

  return <MDBDataTableV5 striped bordered hover entriesOptions={[5, 10, 25]} entries={10} pagesAmount={4} data={datatable} fullPagination proSelect />;
}